// extracted by mini-css-extract-plugin
export default {"parent":"LimitPopup2_parent__ozSnk","main":"LimitPopup2_main__RTl8l","heading":"LimitPopup2_heading__aZ-9+","para":"LimitPopup2_para__0pe3k","btn":"LimitPopup2_btn__cuD0P"};